module.exports = __webpack_public_path__ + "img/pmg1.a58c159b.png";